import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 120B7778-EAE8-444B-AEDF-9F7793BF6A35
 * name view-grid-plus-outline
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-grid-plus-outline.svg
 * tags
 * - View 
 */
export const ViewGridPlusOutlineIcon = createSvgIcon(<><path d="M3 21H11V13H3M5 15H9V19H5M3 11H11V3H3M5 5H9V9H5M13 3V11H21V3M19 9H15V5H19M18 16H21V18H18V21H16V18H13V16H16V13H18Z" /></>, 'ViewGridPlusOutlineIcon');
export default ViewGridPlusOutlineIcon